// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".startup-key-figures__title[data-v-108d0240]{font-size:1.25rem}.startup-key-figures__item[data-v-108d0240]{padding-top:3rem}.startup-key-figures__value[data-v-108d0240]{font-size:5rem}.startup-key-figures__label[data-v-108d0240]{font-size:1.2rem;color:#51596c}", ""]);
// Exports
module.exports = exports;
